// extracted by mini-css-extract-plugin
export default {"input":"CreatePasswordForm_input__q2+q8","word":"CreatePasswordForm_word__tIwO1"};